import { useState, useEffect } from 'react'
import throttle from 'lodash.throttle'

import screens from 'resources/screens'

export enum Screen {
  PHONE = 'phone',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
}

const getDeviceConfig = (width: number) => {
  if (width <= screens.phone) {
    return Screen.PHONE
  }
  if (width > screens.phone && width <= screens.tablet) {
    return Screen.TABLET
  }
  return Screen.DESKTOP
}

const useBreakpoint = () => {
  const [brkPnt, setBrkPnt] = useState<Screen>(() =>
    getDeviceConfig(typeof window !== 'undefined' ? window.innerWidth : 0)
  )

  useEffect(() => {
    const calcInnerWidth = throttle(() => {
      setBrkPnt(getDeviceConfig(window.innerWidth))
    }, 200)
    window.addEventListener('resize', calcInnerWidth)
    return (): void => window.removeEventListener('resize', calcInnerWidth)
  }, [])

  return brkPnt
}

export const useIsPhone = () => {
  const point = useBreakpoint()
  return point === Screen.PHONE
}

export const useIsTablet = () => {
  const point = useBreakpoint()
  return point === Screen.TABLET
}

export const useIsDesktop = () => {
  const point = useBreakpoint()
  return point === Screen.DESKTOP
}

export default useBreakpoint
